import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";

const time = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const ChatThread = ({ messages, me, onSend, emptyText, className = "" }) => {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [messages.length]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try { await onSend(text); setText(""); } finally { setSending(false); }
  };

  return (
    <div className={`flex flex-col min-h-0 ${className}`} data-testid="chat-thread">
      <div className="flex-1 overflow-y-auto space-y-3 p-4" data-testid="chat-messages">
        {messages.length === 0 && <p className="text-sm text-[var(--rf-grey)]" data-testid="chat-empty">{emptyText}</p>}
        {messages.map((m) => {
          const mine = m.sender === me;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`chat-message-${m.id}`}>
              <div className={`max-w-[80%] px-3 py-2 text-sm whitespace-pre-wrap ${mine ? "bg-[var(--rf-ink)] text-white" : "bg-[var(--rf-soft)]"}`}>
                {m.text}
                <span className={`block rf-mono text-[9px] mt-1 ${mine ? "text-white/50" : "text-[var(--rf-grey)]"}`}>{time(m.created_at)}</span>
              </div>
            </div>
          );
        })}
        <div ref={end} />
      </div>
      <form onSubmit={submit} className="flex border-t rf-line">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi un messaggio…"
          className="flex-1 px-4 h-12 text-sm outline-none bg-transparent" data-testid="chat-input" />
        <button disabled={sending || !text.trim()} className="px-4 text-[var(--rf-ink)] hover:text-[var(--rf-red)] disabled:opacity-30" data-testid="chat-send-button" aria-label="Invia">
          <Send size={16} />
        </button>
      </form>
    </div>
  );
};
